import man1 from "../assets/avatars/man-1.png";
import women1 from "../assets/avatars/women-1.png";
import women2 from "../assets/avatars/women-2.png";
import women3 from "../assets/avatars/women-3.png";
import women4 from "../assets/avatars/women-4.png";

export const AVATAR_CHARACTERS = [
  {
    id: "man-1",
    name: "Penuntut Ilmu",
    name_en: "Scholar",
    description: "Pencinta ilmu dan penjelajah hikmah",
    description_en: "Loves knowledge and explores wisdom",
    price: 1240,
    rarity: "shalih",
    theme: { gradient: "from-amber-200 to-orange-300" },
    stats: { wisdom: 90, courage: 75, empathy: 60 },
    image: man1,
    category: "male",
  },
  {
    id: "women-1",
    name: "Muslimah 1",
    name_en: "Muslimah 1",
    description: "Berani dan penuh empati",
    description_en: "Brave and empathetic",
    price: 980,
    rarity: "dasar",
    theme: { gradient: "from-pink-200 to-rose-300" },
    stats: { wisdom: 70, courage: 80, empathy: 85 },
    image: women1,
    category: "female",
  },
  {
    id: "women-2",
    name: "Muslimah 2",
    name_en: "Muslimah 2",
    description: "Penyabar dan rendah hati",
    description_en: "Patient and humble",
    price: 1100,
    rarity: "shalih",
    theme: { gradient: "from-pink-200 to-rose-300" },
    stats: { wisdom: 82, courage: 68, empathy: 88 },
    image: women2,
    category: "female",
  },
  {
    id: "women-3",
    name: "Muslimah 3",
    name_en: "Muslimah 3",
    description: "Cerdas dan kreatif",
    description_en: "Smart and creative",
    price: 1450,
    rarity: "teladan",
    theme: { gradient: "from-pink-200 to-rose-300" },
    stats: { wisdom: 88, courage: 72, empathy: 76 },
    image: women3,
    category: "female",
  },
  {
    id: "women-4",
    name: "Muslimah 4",
    name_en: "Muslimah 4",
    description: "Aktif dan penuh semangat",
    description_en: "Active and spirited",
    price: 1600,
    rarity: "muttaqin",
    theme: { gradient: "from-pink-200 to-rose-300" },
    stats: { wisdom: 80, courage: 90, empathy: 70 },
    image: women4,
    category: "female",
  },
];

export const DEFAULT_AVATAR = man1;

export const getCharactersByGender = (gender) => {
  if (!gender) return AVATAR_CHARACTERS;
  return AVATAR_CHARACTERS.filter((c) => c.category === gender);
};
